import { render, staticRenderFns } from "./GeneralInvoicesView.vue?vue&type=template&id=66fd33bf&"
import script from "./GeneralInvoicesView.vue?vue&type=script&lang=js&"
export * from "./GeneralInvoicesView.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInvoicesView.vue?vue&type=style&index=0&id=66fd33bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports